// extracted by mini-css-extract-plugin
module.exports = {"award":"award-monte-carlo-module--award--4j0bF"};